function assertIsType(type, value, msg) {
    console.assert(typeof value === type, msg);
}

export function assertValidShelfConfig({ width, height, coverHeight, coverY, leftClip, rightClip, bottomAdhesive }) {
    assertIsType("number", width, "width is not a number");
    assertIsType("number", height, "height is not a number");
    assertIsType("number", coverHeight, "Ticket Strip Height is not a number");
    assertIsType("number", coverY, "Ticket Strip y is not a number");
    assertIsType("number", leftClip.x, "Left Clip x is not a number");
    assertIsType("number", leftClip.y, "Left Clip y is not a number");
    assertIsType("number", rightClip.x, "Right Clip x is not a number");
    assertIsType("number", rightClip.y, "Right Clip .y is not a number");

    assertIsType("boolean", bottomAdhesive, "Bottom Adhesive is not a boolean");
}

export function assertValidCaddyConfig({
    width,
    height,
    contentX,
    contentY,
    contentWidth,
    contentHeight,
    coverHeight,
    ladderWidth,
    ladderHeight,
    topPawl,
    bottomPawl,
    pawlInterval,
    intermediateLadderCount,
    clipDevices,
    leftAdhesive,
    rightAdhesive,
    bottomAdhesive
}) {
    assertIsType("number", width, "Width is not a number");
    assertIsType("number", height, "Height is not a number");
    assertIsType("number", contentX, "Content x is not a number");
    assertIsType("number", contentY, "Content y is not a number");
    assertIsType("number", contentWidth, "Content width is not a number");
    assertIsType("number", contentHeight, "Content height is not a number");
    assertIsType("number", coverHeight, "Ticket strip is not a number");
    assertIsType("number", ladderWidth, "Ladder width is not a number");
    assertIsType("number", ladderHeight, "Ladder height is not a number");
    assertIsType("number", topPawl, "Top pawl is not a number");
    assertIsType("number", bottomPawl, "Bottom pawl is not a number");
    assertIsType("number", pawlInterval, "Pawl interval is not a number");
    assertIsType("number", intermediateLadderCount, "Intermediate ladder count is not a number");

    console.assert(Array.isArray(clipDevices));
    console.assert(clipDevices.length > 0);
    for (const anchor of clipDevices) {
        const index = clipDevices.findIndex(a => a === anchor);

        assertIsType("number", anchor.x, `Anchor ${index} x is not a number`);
        assertIsType("number", anchor.y, `Anchor ${index} y is not a number`);
    }

    assertIsType("boolean", leftAdhesive, "Left adhesive is not a boolean");
    assertIsType("boolean", rightAdhesive, "Right adhesive is not a boolean");
    assertIsType("boolean", bottomAdhesive, "Bottom adhesive is not a boolean");
}



// WEBPACK FOOTER //
// ./src/utils/validators.js